import React, { useState } from "react";
import { Box, IconButton, Drawer, Typography } from "@mui/material";
import { Menu, X, ChevronLeft } from "lucide-react";
import TopNavBar from "../components/TopNavBar";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";

type Props = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
};

export default function MainLayout({ children, title, description, showBackButton = false, onBackClick }: Props) {
  const { user, setUser } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    setUser(null);
    navigate("/login");
  };

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", width: "100%", flexDirection: "column" }}>
      {/* Top Navigation Bar */}
      <TopNavBar
        userName={user?.fullName || "usuario"}
        onLogout={handleLogout}
      />

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          minHeight: "100vh",
          bgcolor: "hsl(0 0% 100%)",
          overflow: "auto",
          mt: 8,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Desktop Title Bar */}
        {title && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              px: 3,
              py: 2,
              borderBottom: "1px solid hsl(220 13% 91%)",
              bgcolor: "hsl(0 0% 100%)",
            }}
          >
            {showBackButton && (
              <IconButton
                onClick={handleBackClick}
                sx={{ color: "hsl(240 5.9% 10%)", p: 1 }}
              >
                <ChevronLeft size={24} />
              </IconButton>
            )}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: "hsl(240 5.9% 10%)",
                }}
              >
                {title}
              </Typography>
              {description && (
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 400,
                    color: "hsl(240 3.8% 46.1%)",
                  }}
                >
                  {description}
                </Typography>
              )}
            </Box>
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
}
